import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { CoreLanguageService } from '../../services/language.service';
import { WebShopService } from '../../services/webShop.service';
import * as moment from "moment";
import { ServiceOpenTimeViewModel } from '../../shared/models';
import { BehaviorSubject, Observable } from 'rxjs';
import { RemoteGroupOrderService } from '../../services/RemoteGroupOrder.service';

interface IServiceOpenTime {
  /** Display text */
  readonly display: string;
  /** Value */
  readonly value: string;
  /** Indicates if ASAP */
  readonly asap: boolean;
}

interface IServiceTimeExpiredData {
  leadTime: number;
  selectedServiceTime: string;
}

@Component({
  selector: 'remoteGroupOrderServiceTimeExpired',
  templateUrl: './remoteGroupOrderServiceTimeExpired.component.html',
  styleUrls: ['./remoteGroupOrderServiceTimeExpired.component.scss']
})
export class RemoteGroupOrderServiceTimeExpiredComponent implements OnInit {

  private _serviceOpenTimeSubject: BehaviorSubject<IServiceOpenTime[]> = new BehaviorSubject<IServiceOpenTime[]>(null);

  /** The list of service open times */
  public get serviceOpenTime$(): Observable<IServiceOpenTime[]> {
    const me = this;
    return me._serviceOpenTimeSubject.asObservable();
  }

  public newServiceTime: ServiceOpenTimeViewModel;
  public iSelectedServiceTime: string = "";

  public isClosed: boolean = false;
  public infoExpired: string = "";
  public serviceOpenTimeViewModels: ServiceOpenTimeViewModel[];

  public get orderASAP(): boolean {
    return this._webShopService.orderASAP;
  }
  public get selectedServiceTime(): string {
    return this.dialogData.selectedServiceTime;
  }

  constructor(public bottomSheetRef: MatBottomSheetRef<RemoteGroupOrderServiceTimeExpiredComponent, "change" | "cancel">
    , private _webShopService: WebShopService
    , private _router: Router
    , private _coreLanguageService: CoreLanguageService
    , private _remoteGroupOrderService: RemoteGroupOrderService
    , @Inject(MAT_BOTTOM_SHEET_DATA) public dialogData: IServiceTimeExpiredData) { }

  ngOnInit() {
    const me = this;
    me._webShopService.getAvailableServiceTimes().then(serviceOpenTimes => {
      me.isClosed = me._isClosed();
      me._serviceOpenTimeSubject.next(serviceOpenTimes);
      me.serviceOpenTimeViewModels = serviceOpenTimes;
      if (me.serviceOpenTimeViewModels && me.serviceOpenTimeViewModels.length > 0) {
        me.newServiceTime = me.serviceOpenTimeViewModels[0];
      } else {
      }
    });
  }

  public timeExpiredLabel(selectedServiceTime: string): string {
    const me = this;
    const _selectedServiceTime = me.timeDisplayValue(selectedServiceTime);
    return me._coreLanguageService.value("phRemoteOrder_Change_Service_Time_Info")
      .replace("{selectedServiceTime}", `<br><span class="emphasized">${_selectedServiceTime}</span><br>`);
  }

  private timeDisplayValue(dateTime: string) {
    return moment(dateTime).format('HH:mm');
  }

  /** selected delivery / pickup day & time */
  private _formatedTime(time: string) {
    return moment(time, 'ddd MMM DD YYYY HH:mm:ss [GMT]ZZ').toISOString();
  }

  public isTimeSelected(availableTime: IServiceOpenTime, selectedTime: string): boolean {
    const me = this;
    const hasAsap = me.orderASAP === availableTime.asap;
    const selected = selectedTime === availableTime.value;
    return selected && hasAsap;
  }

  public setRequestServiceTime(index: string) {
    const me = this;
    me.newServiceTime = me.serviceOpenTimeViewModels[+index];
  }

  private setServiceTimeValue() {
    const me = this;
    me._webShopService.setServiceOrderTime(me.newServiceTime.value);
    me._remoteGroupOrderService.setSelectedServiceTime(me._formatedTime(me.newServiceTime.value));
    me._remoteGroupOrderService.serviceTimeChanged();
  }

  public confirm() {
    const me = this;
    me.setServiceTimeValue();
    me.bottomSheetRef.dismiss("change");
  }

  public cancel() {
    const me = this;
    me.bottomSheetRef.dismiss("cancel");
    me._router.navigateByUrl("/");
  }

  private _isClosed() {
    const me = this;
    let now = moment();
    let serviceEndTime = me.getEndServiceTime();
    const possibleTimeForOrder = 5;
    me.isClosed = now > serviceEndTime.add(possibleTimeForOrder, "minutes");
    return this.isClosed;
  }

  private getEndServiceTime() {
    const me = this;
    const serviceOpenTime = me._webShopService.getOpenTimeService();
    const serviceOrderDayTime = moment(me._webShopService.serviceOrderTime);
    const serviceStartTime = moment(serviceOrderDayTime)
      .hours((serviceOpenTime[0].start_hms / 10000) % 100)
      .minutes((serviceOpenTime[0].start_hms / 100) % 100)
      .seconds(serviceOpenTime[0].start_hms % 100);
    const serviceEndTime = moment(serviceOrderDayTime)
      .hours(
        (serviceOpenTime[serviceOpenTime.length - 1].end_hms / 10000) % 100
      )
      .minutes(
        (serviceOpenTime[serviceOpenTime.length - 1].end_hms / 100) % 100
      )
      .seconds(serviceOpenTime[serviceOpenTime.length - 1].end_hms % 100);
    if (serviceEndTime.isBefore(serviceStartTime)) {
      serviceEndTime.add(1, "days");
    }
    return serviceEndTime;
  }


}
